export const PHONE_CALL_BOOKING__PERMISSIONS = {
  PHONE_CALL_BOOKING: {
    MANAGE: {
      permissionGroupName: 'Zarządzanie terminami spotkań bezplatnej konsultacji ',
      NONE: {
        dbName: 'PHONE_CALL_BOOKING__PHONE_CALL_BOOKING__MANAGE__NONE',
        name: 'Brak uprawnień',
        description:
          'Brak dostępu do zarządzania terminami spotkań dla bezplatnej konsultacji z mentorami AlgoAcademy.'
      },
      ENABLED: {
        dbName: 'PHONE_CALL_BOOKING__PHONE_CALL_BOOKING__MANAGE__ENABLED',
        name: 'Możliwość zarządzania terminami spotkań dla bezplatnej konsultacji z mentorami AlgoAcademy',
        description:
          'Możliwość dodawania, edytowania i usuwania terminów spotkań dla bezplatnej konsultacji z mentorami AlgoAcademy. Podgląd danych klientów, którzy zarezerwowali spotkanie.'
      }
    }
  }
} as const
